@if(service.viewDroplistItems.length){
<div class='devo-commitments-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	<ng-container [ngSwitch]="selectedViewItem.uniqueId">
		<devo-commitments-commitments-view-part
			*ngSwitchCase="service.viewId.Commitments"></devo-commitments-commitments-view-part>
	</ng-container>
	}
</div>
}